import React, {useState} from 'react';
import {submitReviewFeedback} from '../../services/reviewFeedbackService';

export default function ReviewFeedbackForm({business, rating, onBack}) {
  const [message, setMessage] = useState('');
  const [contact, setContact] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    setStatus('sending');
    setError('');

    try {
      await submitReviewFeedback(business, {rating, message, contact});
      setStatus('sent');
    } catch (err) {
      setError(err.message || 'We could not send your feedback. Please try again.');
      setStatus('idle');
    }
  }

  if (status === 'sent') {
    return (
      <div className="mx-auto mt-12 max-w-2xl rounded-2xl bg-[#f5f8fc] p-8 text-center sm:p-12" role="status">
        <h2 className="text-2xl font-black sm:text-3xl">Thank you for your feedback.</h2>
        <p className="mt-3 text-slate-600">Your response has been received.</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="mx-auto mt-12 max-w-2xl rounded-2xl bg-[#f5f8fc] p-6 sm:p-10">
      <h2 className="text-2xl font-black sm:text-3xl">Tell us about your experience</h2>
      <p className="mt-3 text-slate-600">What could {business.business_name} do better?</p>
      <label htmlFor="review-feedback" className="mt-7 block text-sm font-bold">Your feedback</label>
      <textarea
        id="review-feedback"
        required
        minLength={10}
        rows={5}
        value={message}
        onChange={(event) => setMessage(event.target.value)}
        placeholder="Tell us what happened (at least 10 characters)"
        className="mt-2 w-full rounded-xl border border-slate-300 bg-white p-4 outline-none focus:border-[#2563eb]"
      />
      <label htmlFor="review-contact" className="mt-5 block text-sm font-bold">Email or phone (optional)</label>
      <input
        id="review-contact"
        type="text"
        value={contact}
        onChange={(event) => setContact(event.target.value)}
        placeholder="If you would like a follow-up"
        className="mt-2 w-full rounded-xl border border-slate-300 bg-white p-4 outline-none focus:border-[#2563eb]"
      />
      {error && <p role="alert" className="mt-4 text-sm font-semibold text-red-700">{error}</p>}
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <button type="submit" disabled={status === 'sending'} className="rounded-xl bg-[#0b1423] px-7 py-4 font-bold text-white disabled:opacity-60">
          {status === 'sending' ? 'Sending…' : 'Send feedback'}
        </button>
        <button type="button" onClick={onBack} className="rounded-xl border border-slate-300 px-7 py-4 font-bold">
          Change my answer
        </button>
      </div>
    </form>
  );
}